import React from 'react'
import { BannerContainerStyled, BannerContainerInnerStyled } from '../Banner.styles'
import { BannerArea } from '../types'

export const BannerContainer: React.FC<{ areaName: BannerArea }> = ({ areaName, children }) => (
  <BannerContainerStyled isDesktop={areaName === 'Desktop'}>
    <BannerContainerInnerStyled>{children}</BannerContainerInnerStyled>
  </BannerContainerStyled>
)
